import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as sdv from 'sugar-design/foundation/variable.js';
import { Avatar as SDAvatar } from 'sugar-design';

import { ROLES } from '@/constants/common';

import './index.styl';

const OTHER_ROLES = {
  HEADHUNTER: 'headhunter',
  AMBASSADOR: 'ambassador',
  DEFAULT: 'default',
};

const ROLE_TO_COLOR = {
  [ROLES.NEWBIE]: sdv.n30,
  [ROLES.FOREGROUND]: sdv.c60,
  [ROLES.INTERVIEWER]: sdv.b50,
  [ROLES.HIRING_MANAGER]: sdv.y60,
  [ROLES.HIGH_HIRING_MANAGER]: sdv.o50,
  [ROLES.HR]: sdv.g60,
  [ROLES.ADMIN]: sdv.v50,
  [ROLES.SUPERADMIN]: sdv.pi50,
  [OTHER_ROLES.DEFAULT]: sdv.n30,
  [OTHER_ROLES.HEADHUNTER]: sdv.pi50,
  [OTHER_ROLES.AMBASSADOR]: sdv.pu50,
};

/**
 * 头像（支持用户组，不支持图片）
 *
 * 不同颜色对应不同角色
 */
class Avatar extends React.Component {
  render() {
    const { name, role, className, users, isTruncationName } = this.props;

    if (users && Array.isArray(users) && !name) {
      if (users.length === 1) {
        const user = users[0];
        return <Avatar name={user.name || user.email} role={user.role} {...this.props} />;
      }

      return (
        <div className={classNames('avatar-multiple', this.props.className)}>
          <div className="avatar-multiple__top">
            {users.slice(0, users.length === 3 ? 1 : 2).map((user, idx) => (
              <Avatar
                key={idx}
                className="avatar-multiple__avatar"
                name={user.name || user.email}
                role={user.role}
              />
            ))}
          </div>
          {users.length >= 3 && (
            <div className="avatar-multiple__bottom">
              {users.slice(users.length === 3 ? 1 : 2, 3).map((user, idx) => (
                <Avatar
                  key={idx}
                  className="avatar-multiple__avatar"
                  name={user.name || user.email}
                  role={user.role}
                />
              ))}
              {users.length > 3 && (
                <Avatar
                  className="avatar-multiple__avatar avatar-multiple__avatar-more"
                  name="..."
                  role={10}
                  isTruncationName={false}
                />
              )}
            </div>
          )}
          {users.length === 3 && (
            <div className="avatar-multiple__shadow-three">
              <div className="avatar-multiple__shadow-three__clip">
                <Avatar
                  className="avatar-multiple__avatar"
                  name={users[1].name || users[1].email}
                  role={users[1].role}
                />
              </div>
            </div>
          )}
          {users.length > 3 && (
            <div className="avatar-multiple__shadow">
              <div className="avatar-multiple__shadow__clip">
                <Avatar
                  className="avatar-multiple__avatar"
                  name={users[2].name || users[2].email}
                  role={users[2].role}
                />
              </div>
            </div>
          )}
        </div>
      );
    }

    if (name) {
      const firstChar = isTruncationName ? name.substr(0, 1).toUpperCase() : name;
      return (
        <div className={className}>
          <SDAvatar
            size="md"
            name={firstChar}
            text={firstChar}
            backgroundColor={ROLE_TO_COLOR[role]}
          />
        </div>
      );
    } else {
      return (
        <div className={className}>
          <SDAvatar size="md" />
        </div>
      );
    }
  }
}

Avatar.defaultProps = {
  role: 10,
  className: '',
  isTruncationName: true,
};

Avatar.propTypes = {
  className: PropTypes.string,
  /**
   * 是否截断 name，如果截断则只显示第一个字符，否则显示全部姓名
   */
  isTruncationName: PropTypes.bool,
  /**
   * 用户名
   */
  name: PropTypes.string,
  /**
   * 用户权限，不同权限对应不同颜色
   */
  role: PropTypes.number,
  /**
   * 用户组，可选。如果没有name有users，则以用户组的形式展示
   */
  users: PropTypes.array,
  /**
   * Avatar style, could be used to specify attributes like height, weight and font size
   */
  style: PropTypes.object,
};

export default Avatar;
